import store from "@/config/vuex/store";

export default [
    {
        path: "/abastecimentos",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [
            {
                path: "/",
                name: "abastecimentosCreate",
                component: () => import('@/pages/Abastecimento/AbastecimentoCreate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "relatorio",
                name: "abastecimentosAnaliticoRead",
                component: () => import('@/pages/Abastecimento/AbastecimentoAnaliticoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "sintetico",
                name: "abastecimentosSinteticoRead",
                component: () => import('@/pages/Abastecimento/AbastecimentoSinteticoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "relatorio",
                name: "abastecimentosAdmAnaliticoRead",
                component: () => import('@/pages/Abastecimento/AbastecimentoAdmAnaliticoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "sintetico",
                name: "abastecimentosAdmSinteticoRead",
                component: () => import('@/pages/Abastecimento/AbastecimentoAdmSinteticoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }         
        ]
    }
]

